import React from 'react'
import {BsFacebook,BsInstagram,BsTwitter} from 'react-icons/bs';
import {FaFacebookF} from 'react-icons/fa';
import styled from 'styled-components';
const SocialIcons = () => {
  return (
    <Container>
        <IconContainer>
          <FaFacebookF size={13}/>
        </IconContainer>

        <IconContainer>
          <BsInstagram size={13}/>
        </IconContainer>

        <IconContainer>
          <BsTwitter size={13}/>
        </IconContainer>
    </Container>
  )
}

export default SocialIcons;

let Container = styled.div`
    display:flex;
    width:100px;
    height:20px;
    justify-content:space-between ;
    margin-bottom:10px;
`

let IconContainer = styled.div`
    display:flex;
    justify-content:center ;
    align-items:center ;
    margin-top: 10px;
    width:25px;
    height:25px;
    border-radius: 100% ;
    background-color:#797B87 ;
    color:#fff;
    transition:color 500ms ease-in-out,background 500ms ease-in-out;
    cursor:pointer;
    :hover{
    background-color:#fff ;
    color:#797B87;
    }
`